import ErrorIcon from 'assets/icon/instances-failed.svg';
import RunningIcon from 'assets/icon/instances-running.svg';
import NormalIcon from 'assets/icon/instances-success.svg';
import WarningIcon from 'assets/icon/warning-status.svg';
import { SystemStatus } from 'constants/global';

const TEXTS = {
  ALT: {
    STATUS: 'Status',
  },
};

const getStatusIcon = (status?: string) => {
  switch (status) {
    case SystemStatus.Warning:
      return WarningIcon;
    case SystemStatus.Error:
      return ErrorIcon;
    case SystemStatus.Normal:
      return NormalIcon;
    default:
      return RunningIcon;
  }
};

export { TEXTS, getStatusIcon };
